import React from 'react';
import style from './list.module.scss';

function KnorrListEmpty() {
  return <p className={style.listEmpty}>No data</p>;
}

export default KnorrListEmpty;
